import { FC } from 'react'

import styled from 'styled-components'

import Waiting from 'src/Assets/Svg/common/waiting.svg?react'
import ErrorIcon from 'src/Assets/Svg/pages-icons/ErrorPayment.svg?react'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import {
  CampaignPayment,
  CampaignPaymentState,
} from 'src/Redux/artistOrderApi/campaignPayment'
import { useRetryCampaignPayment } from 'src/Hooks/useCampaignPayment'
import {
  PAYMENT_FAILED_TEXT,
  PAYMENT_IN_PROGRESS_TEXT,
} from 'src/Constants/paymentStatusTexts'

const Text = styled.div`
  max-width: 400px;
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

const StyledErrorIcon = styled(ErrorIcon)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.mediumRed};
`

interface CampaignPaymentInfoProps {
  payment: CampaignPayment
  platform: CampaignPlatformTypeEnum
  campaignId: number
}

export const CampaignPaymentInfo: FC<CampaignPaymentInfoProps> = ({
  payment,
  platform,
  campaignId,
}) => {
  const { retryPayment, isRetrying } = useRetryCampaignPayment()

  if (payment.state === CampaignPaymentState.InProgress) {
    return (
      <>
        <Waiting />
        <Text>{PAYMENT_IN_PROGRESS_TEXT}</Text>
      </>
    )
  }

  const handleTryAnotherMethodClick = (): void => {
    retryPayment(platform, campaignId, payment.orderId)
  }

  return (
    <>
      <StyledErrorIcon width={40} height={40} />
      <Text>{PAYMENT_FAILED_TEXT}</Text>
      <GreyTextButton
        loading={isRetrying}
        disabled={isRetrying}
        onClick={handleTryAnotherMethodClick}
      >
        Try another payment method
      </GreyTextButton>
    </>
  )
}
